export const dataHooks = {
  baseCalendar: 'baseCalendarHook',
};
